<template>
  <div>
    <loading v-if="isLoading" />

    <v-data-table :headers="headers" :items="turmas" class="elevation-1">
      
      <!--========== CAMPOS ACIMA DA TABELA ==========-->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-row style="align-items: center; text-align: center; justify-content: end;">
              <v-col cols="4" sm="4" md="4">
                <v-select
                  style="margin-top: 30px; width: 200px !important;"
                  :items="anosLectivosAll"
                  v-model="anoLectivoSelected"
                  item-value="descricao"
                  item-text="novadescricao"
                  @change="onAnoLectivoChange()"
                  label="Selecione o Ano lectivo"
                  return-object
                ></v-select>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <!--========== FIM CAMPOS ACIMA DA TABELA ==========-->

      <template v-slot:item.index="{ item }">
        <span>{{ turmas.indexOf(item) + 1 }}</span>
      </template>

      <!--======= BOTÃO MENU (ACTIONS) ================-->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab dark color="teal" style="color: white" v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="desabilitarTurma(item)">
              <v-icon class="mr-2" style="color: red">delete</v-icon>
              <span> - Eliminar </span>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data> Dados não encontrados! </template>
    </v-data-table>
    <!--======= FIM BOTÃO MENU (ACTIONS) ================-->
  </div>
</template>
<script>
import axios from "../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
import loading from "../../../components/loading.vue";
export default {
  components: {
    loading,
  },
  data: () => ({
    turmas: [],
    anosLectivosAll: [],
    anoLectivoSelected: null,
    isLoading: false,
    headers: [
      { text: "#", value: "index" },
      { text: "Turma", value: "turma" },
      { text: "Curso", value: "curso" },
      { text: "Classe", value: "classe_descricao" },
      { text: "Periodo", value: "periodo" },
      { text: "Data", value: "data" },
      { text: "Actions", value: "action", sortable: false },
    ],
  }),

  computed: {
    anoLectivo() {
      return ls.get("anolectivo");
    },
  },

  created() {
    this.initializeAnosLectivoAndTurmasAll();
  },

  methods: {
     async initializeAnosLectivoAndTurmasAll() {
        this.isLoading = true;
        try {
          // Inicializa os anos lectivos
          this.anosLectivosAll = await this.initializeAnosLectivo();

          // Selecione o ano lectivo desejado
          this.anoLectivoSelected = this.anosLectivosAll.find(ano => ano.descricao === this.anoLectivo);

          // Inicializa as turmas usando o ano lectivo selecionado
          await this.initializeTurmasByAnoLectivo(this.anoLectivoSelected.idAnoLectivo);
        } catch (error) {
          Swal.fire("Informação", "<p>Erro ao carregar anos lectivos e turmas!</p>", "error");
        } finally {
          this.isLoading = false;
        }
      },

      async initializeAnosLectivo() {
        return axios.get('/listarAnoLectivoAll').then(res => res.data);
      },

      async initializeTurmasByAnoLectivo(idAnoLectivo) {
        this.isLoading = true;
        try {
          // Carrega as turmas para o ano lectivo fornecido
          this.turmas = await axios.get(`/getAllTurmasVazias/${idAnoLectivo}`).then(res => res.data);
        } catch (error) {
          Swal.fire("Informação", "<p>Erro ao carregar as turmas!</p>", "error");
        } finally {
          this.isLoading = false;
        }
      },

      async onAnoLectivoChange() {
        // Chamado quando o ano lectivo é alterado
        await this.initializeTurmasByAnoLectivo(this.anoLectivoSelected.idAnoLectivo);
      },
  

    desabilitarTurma(turma) {
      if(turma) {
        let params = {
          idTurma: turma.idTurma
        }

        Swal.fire({
          title: 'Eliminar Turma',
          text: 'Deseja continuar com esta operação?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'green',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Confirmar',
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.isLoading = true;
            try {
              let response = await axios.post("/desativarTurma", params).then((res) => res.data);
              
              if (response.affectedRows >= 1) {
                Swal.fire('Informação', '<p>Turma eliminada com sucesso!</p>', 'success')
                this.initializeAnosLectivoAndTurmasAll();
              } else {
                Swal.fire('Informação', '<p>Erro durante a eliminação da turma!</p>', 'error')
              }
            } catch (error) {
              Swal.fire('Informação', '<p>Erro durante a eliminação da turma!</p>', 'error')
            } finally {
              this.isLoading = false;
            }
          }
        })
      }
    }
  }
};
</script>
<style scoped>
.cardTitle {
  text-align: center;
  font-size: 20px;
  padding-top: 5px;
  font-weight: 1;
}
.cancelartBtn {
  background-color: #eb1a1a;
  font-weight: bold;
}
.salvartBtn {
  background-color: #11cf11;
  font-weight: bold;
}
</style>